import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    overflow: 'auto',
    padding: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 0),
    },

    '& .content': {
      width: '100%',
      maxWidth: 960,
      margin: '0 auto',
    },

    '& .account': {
      '&-data': {
        '&-container': {
          marginBottom: theme.spacing(3),
        },

        '&-content': {
          display: 'flex',
          padding: theme.spacing(3),

          [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
          },
        },

        '&-avatar': {
          '&-container': {
            flexGrow: 1,
          },
        },

        '&-inputs': {
          '&-container': {
            flexGrow: 3,
            [theme.breakpoints.up('sm')]: {
              paddingLeft: theme.spacing(3),
            },

            [theme.breakpoints.down('xs')]: {
              paddingTop: theme.spacing(3),
            },

            '& .input-container': {
              '&.name': {
                marginBottom: theme.spacing(3),
              },
              '& .input': {
                display: 'flex',
              },
            },
          },
        },
      },

      '&-password': {
        '&-content': {
          display: 'flex',
          padding: theme.spacing(3),
          flexDirection: 'column',

          '& .input-container': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          },
        },

        '&-current': {
          '&-container': {
            display: 'flex',
            marginBottom: theme.spacing(3),

            [theme.breakpoints.up('sm')]: {
              '& .input-container': {
                '&.current-password': {
                  '& .input': {
                    maxWidth: 'calc((100% - 16px) / 2)',
                  },
                },
              },
            },
          },
        },

        '&-new': {
          '&-container': {
            display: 'flex',

            [theme.breakpoints.up('sm')]: {
              '& .input-container': {
                '&.new-password': {
                  paddingRight: theme.spacing(1),

                  '&-confirm': {
                    paddingLeft: theme.spacing(1),
                  },
                },
              },
            },

            [theme.breakpoints.down('xs')]: {
              flexDirection: 'column',

              '& .input-container': {
                '&.new-password': {
                  marginBottom: theme.spacing(3),
                },
              },
            },
          },
        },
      },

      '&-footer': {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(3),
      },
    },
  },
}));

export default styles;
